module.exports = __webpack_public_path__ + "images/matt_stephenson.jpg?v=f8bb23c26a50e84c25341544b369db43";